import { RefObject } from 'react'

export const scrollTo = (target: RefObject<HTMLElement | null>) => {
    if (target.current) {
        target.current.scrollIntoView({
        behavior: 'smooth',
        })
    }
}